export const appMeta = {
  productName: "FlowWise",
  tagline: "Orchestrate smarter conversations",
  demoCredentials: {
    email: "admin@example.com",
    password: "password",
  },
};

export const currentUser = {
  name: "Admin User",
  role: "Administrator",
  initials: "AU",
};

export const navigation = [
  { key: "dashboard", label: "Dashboard", icon: "dashboard" },
  { key: "businessDetails", label: "Business Details" },
  { key: "intents", label: "Intents" }, 
  { key: "pdfDocuments", label: "PDF Documents" },
  { key: "agentToneControl", label: "Agent Tone Control", icon: "settings" },
  { key: "settings", label: "Settings", icon: "settings" },
];

// export const dashboardPageData = {
//   stats: [
//     {
//       key: "calls",
//       label: "Total Calls",
//       value: 2451,
//       delta: 12,
//       deltaPercent: 0.05,
//       trend: "up",
//       icon: "phone",
//     },
//     {
//       key: "agents",
//       label: "Total Minutes",
//       value: 24,
//       delta: 2,
//       deltaPercent: 0.09,
//       trend: "up",
//       icon: "agents",
//     },
//     {
//       key: "customers",
//       label: "Completed Calls",
//       value: 1234,
//       delta: -31,
//       deltaPercent: -0.03,
//       trend: "down",
//       icon: "users",
//     },
//     {
//       key: "revenue",
//       label: "Total Cost",
//       value: 28300,
//       delta: 18,
//       deltaPercent: 0.079,
//       trend: "up",
//       icon: "dollar",
//       isCurrency: true,
//     },
//   ],
//   weeklyCallVolume: {
//     title: "Weekly Call Volume",
//     labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
//     values: [250, 320, 295, 410, 470, 210, 170],
//   },
//   revenueTrend: {
//     title: "Revenue Trend",
//     labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
//     values: [12000, 15000, 19000, 21500, 25500, 29800],
//   },
//   callTypes: {
//     title: "Call Type Distribution",
//     segments: [
//       { key: "sales", label: "Sales", value: 45, color: "#0f766e" },
//       { key: "support", label: "Support", value: 32, color: "#f97316" },
//       { key: "general", label: "General", value: 23, color: "#0891b2" },
//     ],
//   },
//   recentActivity: [
//     {
//       id: 1,
//       text: "New promotion created",
//       by: "John Doe",
//       time: "2 minutes ago",
//     },
//     {
//       id: 2,
//       text: "Configuration updated",
//       by: "Sarah Smith",
//       time: "15 minutes ago",
//     },
//     {
//       id: 3,
//       text: "Business info updated",
//       by: "Mike Johnson",
//       time: "1 hour ago",
//     },
//     { id: 4, text: "New call log entry", by: "System", time: "2 hours ago" },
//     { id: 5, text: "PDF uploaded", by: "Jane Wilson", time: "3 hours ago" },
//   ],
// };

export const promotionsData = {
  filters: ["All", "Active", "Scheduled", "Expired"],
  promotions: [
    {
      id: "promo-1",
      title: "Summer Sale",
      description: "Get 20% off all products this summer",
      discount: 20,
      startDate: "2026-06-01",
      endDate: "2026-08-31",
      status: "Active",
    },
    {
      id: "promo-2",
      title: "New Customer Discount",
      description: "First-time customers get 15% off",
      discount: 15,
      startDate: "2026-01-01",
      endDate: "2026-12-31",
      status: "Active",
    },
    {
      id: "promo-3",
      title: "Spring Refresh",
      description: "Seasonal offers for returning customers",
      discount: 10,
      startDate: "2026-03-15",
      endDate: "2026-04-30",
      status: "Scheduled",
    },
  ],
};

export const intentsData = {
  categories: ["Sales", "Support", "Billing", "General"],
  intents: [
    {
      id: "intent-1",
      name: "Product Inquiry",
      status: "Active",
      category: "Sales",
      description: "Customer asking about product features or availability",
      keywords: ["product", "features", "specifications", "available"],
      response:
        "I'd be happy to help you learn more about our products. What specific product are you interested in?",
    },
    {
      id: "intent-2",
      name: "Technical Support",
      status: "Active",
      category: "Support",
      description: "Customer needs technical assistance",
      keywords: ["help", "not working", "error", "issue", "problem"],
      response:
        "I understand you're experiencing a technical issue. Let me help you troubleshoot. Can you describe what's happening?",
    },
    {
      id: "intent-3",
      name: "Billing Question",
      status: "Active",
      category: "Billing",
      description: "Inquiries about billing, invoices, or payments",
      keywords: ["billing", "invoice", "payment", "charge", "refund"],
      response:
        "I can help you with your billing inquiry. Could you please provide more details about your question?",
    },
  ],
};

export const pdfDocumentsData = {
  categories: [
    { key: "all", label: "All" },
    { key: "product", label: "Product Information" },
    { key: "support", label: "Support Documentation" },
    { key: "policies", label: "Policies" },
    { key: "general", label: "General" },
  ],
  documents: [
    {
      id: "doc-1",
      name: "Product Catalog 2026.pdf",
      size: "2.4 MB",
      date: "2026-01-11",
      category: "product",
      description: "Complete product catalog with specifications and pricing",
    },
    {
      id: "doc-2",
      name: "Customer Support Guide.pdf",
      size: "1.2 MB",
      date: "2026-01-15",
      category: "support",
      description: "Comprehensive guide for customer support agents",
    },
    {
      id: "doc-3",
      name: "Company Policies.pdf",
      size: "860 KB",
      date: "2026-01-10",
      category: "policies",
      description: "Official company policies and procedures",
    },
  ],
};

export const businessDetailsData = {
  company: {
    name: "Acme Corporation",
    industry: "Technology",
    description:
      "Acme Corporation builds AI-powered communication tools that help teams deliver faster, more human support at scale.",
  },
  address: {
    street: "123 Main Street",
    city: "San Francisco",
    state: "CA",
    zip: "94105",
  },
  contact: {
    phone: "+1 (555) 123-4567",
    email: "contact@acme.com",
    website: "www.acme.com",
  },
  hours: "Mon - Fri: 8:00 AM - 6:00 PM PST",
  twilioPhone: "+1 (555) 987-6543",
  profileNote:
    "This information is used across all your AI agents and customer interactions.",
};

export const twilioManagementData = {
  status: "Connected",
  accountSid: "AC4f1b8c9d0e1234567890abcdef12345",
  authToken: "twilio_auth_token_1234567890abcdef",
  webhookUrl: "https://api.flowwise.ai/twilio/webhook",
  numbers: [
    {
      id: "twilio-1",
      label: "Primary Support Line",
      value: "+1 (555) 010-2233",
      status: "Active",
    },
    {
      id: "twilio-2",
      label: "Sales Line",
      value: "+1 (555) 010-1144",
      status: "Active",
    },
    {
      id: "twilio-3",
      label: "After Hours",
      value: "+1 (555) 010-7788",
      status: "Routing",
    },
  ],
  insights: [
    { key: "callsToday", label: "Calls Today", value: 184 },
    { key: "avgDuration", label: "Avg. Duration", value: "4m 12s" },
    { key: "latency", label: "Webhook Latency", value: "312ms" },
  ],
};

export const settingsData = {
  account: {
    email: "admin@example.com",
    currentPassword: "password",
    newPassword: "password",
    confirmPassword: "password",
  },
  accountInfo: {
    plan: "Enterprise",
    createdAt: "January 1, 2026",
    lastLogin: "January 26, 2026",
  },
  notifications: [
    {
      key: "emailAlerts",
      label: "Email Alerts",
      description: "Receive important alerts via email",
      enabled: true,
    },
    {
      key: "callNotifications",
      label: "Call Notifications",
      description: "Get notified about incoming calls",
      enabled: true,
    },
    {
      key: "systemUpdates",
      label: "System Updates",
      description: "Receive updates about new features",
      enabled: false,
    },
    {
      key: "weeklyReports",
      label: "Weekly Reports",
      description: "Get weekly performance summaries",
      enabled: true,
    },
  ],
  securityActions: [
    "Enable Two-Factor Auth",
    "View Active Sessions",
    "Download Account Data",
  ],
  apiKeys: [
    {
      id: "key-1",
      label: "Production API Key",
      value: "sk_live_xxxxxxxxxxxxxxxxxxxx1234",
    },
    {
      id: "key-2",
      label: "Test API Key",
      value: "sk_test_xxxxxxxxxxxxxxxxxxxx5678",
    },
  ],
};
